module.exports = __webpack_public_path__ + "img/杜宾-2.77b1b27b.jpg";